import { useState } from "react";

import { FacebookIcon } from '../../../components/ui/icons/common/facebook';
import { TwitterIcon } from '../../../components/ui/icons/common/twitter';
import { WhatsAppIcon } from '../../../components/ui/icons/common/whatsapp';
import { Copy, Check } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

export function NewsShare() {
	const [copied, setCopied] = useState(false);
	const currentUrl = window.location.href;

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(currentUrl);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (err) {
			 // console.error('Falha ao copiar:', err);
		}
	};

	return (
		<div className="w-full h-auto pb-4 mb-4 lg:mb-0">
			<div className="w-full flex flex-col lg:flex-row items-center justify-center lg:justify-start bg-white dark:bg-surface-dark-alt rounded-2xl lg:rounded-xl px-6 lg:px-6 py-5 lg:py-4 shadow-sm dark:shadow-premium-dark border border-transparent dark:border-border-dark transition-colors">

				<span className="font-semibold text-lg lg:text-sm text-gray-900 dark:text-gray-100 uppercase tracking-wide cursor-default mb-5 lg:mb-0 lg:mr-6">
					Compartilhar
				</span>

				<div className="flex gap-4 lg:gap-3">
					<button
						onClick={handleCopy}
						title="Copiar Link"
						className={`w-14 h-14 lg:w-10 lg:h-10 flex items-center justify-center rounded-2xl lg:rounded-xl cursor-pointer text-white transition-all shadow-sm border-none relative overflow-hidden group/copy ${copied ? 'bg-green-600' : 'bg-gray-800 dark:bg-gray-700'}`}
					>
						<AnimatePresence mode="wait" initial={false}>
							{copied ? (
								<motion.div
									key="check"
									initial={{ scale: 0, opacity: 0 }}
									animate={{ scale: 1, opacity: 1 }}
									exit={{ scale: 0, opacity: 0 }}
								>
									<Check size={20} />
								</motion.div>
							) : (
								<motion.div
									key="copy"
									initial={{ scale: 0, opacity: 0 }}
									animate={{ scale: 1, opacity: 1 }}
									exit={{ scale: 0, opacity: 0 }}
								>
									<Copy size={18} />
								</motion.div>
							)}
						</AnimatePresence>
					</button>

					<a
						href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`}
						target="_blank"
						rel="noopener noreferrer"
						title="Facebook"
						className="w-14 h-14 lg:w-10 lg:h-10 flex items-center justify-center bg-[#3B5998] rounded-2xl lg:rounded-xl text-white hover:-translate-y-1 transition-transform shadow-sm [&_svg]:h-6 lg:[&_svg]:h-5 [&_svg]:fill-white"
					>
						<FacebookIcon />
					</a>

					<a
						href={`https://x.com/intent/post?url=${encodeURIComponent(currentUrl)}`}
						target="_blank"
						rel="noopener noreferrer"
						title="Twitter - X"
						className="w-14 h-14 lg:w-10 lg:h-10 flex items-center justify-center bg-[#1DA1F2] rounded-2xl lg:rounded-xl text-white hover:-translate-y-1 transition-transform shadow-sm [&_svg]:h-6 lg:[&_svg]:h-5 [&_svg]:fill-white"
					>
						<TwitterIcon />
					</a>

					<a
						href={`https://wa.me?text=${encodeURIComponent(currentUrl)}`}
						target="_blank"
						rel="noopener noreferrer"
						data-action="share/whatsapp/share"
						title="WhatsApp"
						className="w-14 h-14 lg:w-10 lg:h-10 flex items-center justify-center bg-[#25D366] rounded-2xl lg:rounded-xl text-white hover:-translate-y-1 transition-transform shadow-sm [&_svg]:h-6 lg:[&_svg]:h-5 [&_svg]:fill-white"
					>
						<WhatsAppIcon />
					</a>
				</div>

			</div>
		</div>
	);
}